import type { RouteInfo, RouteStatus } from '../../../services/iam';

export interface RouteDomainGroup {
    readonly domain: string;
    readonly routes: readonly RouteInfo[];
    readonly counts: Readonly<Record<RouteStatus, number>>;
}

function emptyCounts(): Record<RouteStatus, number> {
    return { migrated: 0, legacy: 0, public: 0, open: 0 };
}

/** migrated / (migrated + legacy) - the one global "how far along" figure shown in the page subtitle. */
export function migratedProgressPct(counts: Readonly<Record<RouteStatus, number>>): number | null {
    const denominator = counts.migrated + counts.legacy;
    if (denominator === 0) return null;
    return Math.round((counts.migrated / denominator) * 100);
}

// "Domain" is display-only vocabulary; the catalog field is `route.area`.
export function groupRoutesByDomain(routes: readonly RouteInfo[]): RouteDomainGroup[] {
    const groups = new Map<string, RouteInfo[]>();
    for (const route of routes) {
        const bucket = groups.get(route.area) ?? [];
        bucket.push(route);
        groups.set(route.area, bucket);
    }

    return Array.from(groups.entries())
        .map(([domain, domainRoutes]) => {
            const counts = domainRoutes.reduce((acc, route) => {
                acc[route.status] += 1;
                return acc;
            }, emptyCounts());
            const sortedRoutes = [...domainRoutes].sort((a, b) => a.path.localeCompare(b.path));
            return { domain, routes: sortedRoutes, counts };
        })
        .sort((a, b) => a.domain.localeCompare(b.domain));
}
